import React from 'react'
import ContactStyle from './contact.module.css'
import {ReactComponent  as EmailIcon} from '../../../../assets/icon/comcat/邮箱.svg'
import {ReactComponent  as PhenoIcon} from '../../../../assets/icon/comcat/手机.svg'
import {ReactComponent  as AddressIcon} from '../../../../assets/icon/comcat/位置.svg'
function ContactUs() {
  return (
    <div className={ContactStyle.ContactUs_app}>
      <div className={ContactStyle.ContactUs_content}>
      <p>
            Contact US
        </p>
        <p>
        lf you are interested in our project or have any problem,comments or suggestions about our database,please contact us by ways listed below.
        </p>
        <div className={ContactStyle.Contact_icon}>
        <p style={{display:"flex",alignItems:"center",margin:"10px 0"}}>
                    <EmailIcon width={25} style={{marginRight:"10px"}}/>
                    <span>sunheng@wbgcas.cn</span>
                </p>
                <p style={{display:"flex",alignItems:"center",margin:"10px 0"}}>
                    <PhenoIcon width={25} style={{marginRight:"10px"}}/>
                    <span>15377572956</span>
                </p>
                <p style={{display:"flex",alignItems:"center",margin:"10px 0"}}>
                    <AddressIcon width={25} style={{marginRight:"10px"}}/>
                    <span>No.201 Jiufeng 1 Road, East Lake High-Tech Development Zone, Wuhan, Hubei, P.R.China</span>
                </p>
        </div>
      </div>
    </div>
  )
}

export default ContactUs
